export default {
  categories: 'श्रेणियाँ',
  segments: 'क्षेत्रों',
  businesses: 'व्यापार',
  active: 'सक्रिय',
  inactive: 'निष्क्रिय',
  noBusinessesCreated: 'कोई व्यवसाय स्थापित नहीं किया गया है',
  newBusiness: 'नया व्यवसाय',
  editBusiness: 'व्यापार संपादित करें',
  businessUrl: 'बिजनेस यूआरएल',
  segment: 'खंड',
  insertExtraDataName: 'अतिरिक्त डेटा का नाम दर्ज करें',
  insertExtraDataValues: 'अतिरिक्त डेटा के मान दर्ज करें',
  delete: 'हटाएँ',
  addExtraData: 'अतिरिक्त डेटा जोड़ें',
  businessSuccessfullyCreated: 'सफलतापूर्वक बनाया व्यापार',
  businessSuccessfullyEdited: 'व्यापार सही ढंग से संशोधित',
  addNewBusiness: 'नया व्यवसाय जोड़ें',
  uploadPhoto: 'फोटो अपलोड करें',
  doYouWantToDeleteThisContact: 'क्या आप इस संपर्क को हटाना चाहते हैं?',
  deleteContact: 'संपर्क स्पष्ट करें',
  contactSuccessfullyDeleted: 'संपर्क सफलतापूर्वक हटाया गया',
  doYouWantToDeleteThisBusiness: 'क्या आप इस व्यवसाय को हटाना चाहते हैं?',
  deleteBusiness: 'व्यापार को साफ़ करें',
  businessSuccessfullyDeleted: 'व्यापार सही ढंग से मिट',
  errorLoadingTheBusiness: 'एक त्रुटि हुई लोडिंग व्यापार',
  addContact: 'संपर्क जोड़ें',
  nameOfTheBusiness: 'व्यापार का नाम',
  noCategories: 'कोई श्रेणियां नहीं',
  noLocation: 'कोई स्थान नहीं',
  noAddress: 'कोई पता नहीं',
  noSegment: 'कोई सेगमेंट नहीं',
  contactSuccessfullyAdded: 'संपर्क सही ढंग से जोड़ा',
  contacts: 'संपर्क',
  noRoles: 'कोई भूमिका नहीं',
  loadingBusinessContacts: 'लोडिंग व्यापार संपर्क',
  noBusinessContacts: 'इस व्यवसाय का कोई संपर्क नहीं है'
}
